import { render, staticRenderFns } from "./DailyEventDetails.vue?vue&type=template&id=56f614c0"
import script from "./DailyEventDetails.vue?vue&type=script&lang=js"
export * from "./DailyEventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports